import React, { useCallback, useEffect, useState } from 'react';

import { Input } from 'ui/input';

const formatCurrencyInputValue = (
  val: string | number | null | undefined
): string => {
  if (val == null || val === '') return '';

  return Math.round(Number(val)).toLocaleString('en-US');
};

type CoaCurrentYearAmountInputProps = {
  coaId: string | number;
  expenseIndex: number;
  expenseLabel?: string;
  amount: string | number | null;
  onAmountChange: (
    coaId: string | number,
    expenseIndex: number,
    amount: number | null
  ) => void;
};

export const CoaCurrentYearAmountInput = ({
  coaId,
  expenseIndex,
  expenseLabel,
  amount,
  onAmountChange,
}: CoaCurrentYearAmountInputProps) => {
  const [useDashPlaceholder, setUseDashPlaceholder] = useState(true);

  useEffect(() => {
    if (amount !== null && amount !== '') {
      setUseDashPlaceholder(false);
    }
  }, [amount]);

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const raw = e.target.value.replace(/[^0-9]/g, '');

      onAmountChange(
        coaId,
        expenseIndex,
        raw ? Number.parseInt(raw, 10) : null
      );
    },
    [coaId, expenseIndex, onAmountChange]
  );

  const handleBlur = useCallback(
    (e: React.FocusEvent<HTMLInputElement>) => {
      const raw = e.target.value.replace(/[^0-9]/g, '');

      if (raw === '') {
        onAmountChange(coaId, expenseIndex, 0);
      }
    },
    [coaId, expenseIndex, onAmountChange]
  );

  return (
    <Input
      type="text"
      value={formatCurrencyInputValue(amount)}
      startAdornment="$"
      onChange={handleChange}
      onBlur={handleBlur}
      placeholder={useDashPlaceholder ? '-' : ''}
      size="medium"
      sx={{ width: 130 }}
      aria-label={`Current year amount for ${expenseLabel ?? 'expense'}`}
      data-testid={`coa-amount-${coaId}-${expenseIndex}`}
    />
  );
};
